import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import httpClient from "../helpers/httpClient";

export const login = createAsyncThunk("auth/login", async (values) => {
  try {
    const response = await httpClient.post("/web/login", values, {
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    const customError = {
      name: "Custom Login error",
      message: error.response.data.message,
      data: error.response.data,
    };
    throw customError;
  }
});
export const refreshToken = createAsyncThunk("auth/refreshToken", async () => {
  try {
    const response = await axios.get(`${baseURL}/auth/refreshToken`, {
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    const customError = {
      name: "Custom axios error",
      message: error.response.data.error,
      data: error.response.data,
    };
    throw customError;
  }
});

export const logout = createAsyncThunk("auth/logout", async () => {
  const response = await httpClient.post("/web/logout", {
    withCredentials: true,
  });
  return response.data;
});

export const sendMailResetPassword = createAsyncThunk(
  "auth/sendMailResetPassword",
  async (values) => {
    try {
      const response = await httpClient.post("/web/forgotPassword", values, {
        withCredentials: true,
      });
      return response.data;
    } catch (error) {
      console.log("error inside the sendMailResetPassword", error);
      const customError = {
        name: "Custom axios error",
        message: error.response.data.message,
        data: error.response.data,
      };
      throw customError;
    }
  }
);

export const verifyResetPasswordCode = createAsyncThunk(
  "auth/sendMailResetPassword",
  async (values) => {
    try {
      const response = await httpClient.post(
        "/web/verifyResetPasswordCode",
        values,
        {
          withCredentials: true,
        }
      );
      return response.data;
    } catch (error) {
      console.log("error inside the verifyResetPasswordCode", error);
      const customError = {
        name: "Custom axios error",
        message: error.response.data.message,
        data: error.response.data,
      };
      throw customError;
    }
  }
);

export const changePreferredLanguage = createAsyncThunk(
  "auth/changePreferredLanguage",
  async (values) => {
    try {
      const response = await axios.put(
        "/web/uerers/preferred-language",
        values
      );
      return response.data;
    } catch (error) {
      const customError = {
        name: "Custom axios error",
        message: error.response.data.message,
        data: error.response.data,
      };
      throw customError;
    }
  }
);

export const getAccessToken = createAsyncThunk(
  "auth/getAccessToken",
  async (refreshToken) => {
    try {
      const response = await httpClient.post(
        "/web/getAccessToken",
        refreshToken,
        {
          withCredentials: true,
        }
      );
      return response.data;
    } catch (error) {
      const customError = {
        name: "Custom axios error",
        message: error.response.data.message,
        data: error.response.data,
      };
      throw customError;
    }
  }
);

export const resetPassword = createAsyncThunk(
  "auth/resetPassword",
  async (values) => {
    try {
      const response = await httpClient.post("/web/resetPassword", values, {
        withCredentials: true,
      });
      return response.data;
    } catch (error) {
      const customError = {
        name: "Custom axios error",
        message: error.response.data.message,
        data: error.response.data,
      };
      throw customError;
    }
  }
);

export const authSlice = createSlice({
  name: "auth",
  initialState: {
    user: null,
    token: null,
    loading: false,
    error: null,
    init: false,
  },
  reducers: {
    setToken: (state, action) => {
      state.token = action.payload;
      state.loading = false;
    },
  },
  extraReducers: (builder) =>
    builder
      .addCase(login.pending, (state) => {
        state.error = null;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.user = action.payload.user;
        state.token = action.payload.token;
        state.loading = false;
        state.init = true;
      })
      .addCase(refreshToken.pending, (state) => {
        state.error = null;
        state.loading = true;
      })
      .addCase(refreshToken.fulfilled, (state, action) => {
        state.user = action.payload.user;
        state.init = true;

        state.token = action.payload.token;
        state.loading = false;
      })
      .addCase(refreshToken.rejected, (state) => {
        state.user = null;
        state.token = null;
        state.loading = false;
      })
      .addCase(logout.fulfilled, (state) => {
        state.user = null;
        state.init = false;
        state.token = null;
      })
      .addCase(login.rejected, (state, action) => {
        state.error = action.error.message;
        state.loading = false;
      })
      .addCase(changePreferredLanguage.pending, (state) => {
        state.error = null;
        state.loading = true;
      })
      .addCase(changePreferredLanguage.fulfilled, (state, action) => {
        state.user = action.payload.user;
        state.loading = false;
      })
      .addCase(changePreferredLanguage.rejected, (state, action) => {
        state.error = action.error.message;
        state.loading = false;
      })
      .addCase(getAccessToken.pending, (state) => {
        state.error = null;
        state.loading = true;
      })
      .addCase(getAccessToken.fulfilled, (state, action) => {
        state.user = action.payload.user;
        state.token = action.payload.token;
        state.loading = false;
        state.init = true;
      })
      .addCase(getAccessToken.rejected, (state, action) => {
        state.error = action.error.message;
        state.loading = false;
      }),
});

export const { setToken } = authSlice.actions;
export default authSlice.reducer;
